import { render } from "./DateAnswer.vue?vue&type=template&id=c6cd030e"
import script from "./DateAnswer.vue?vue&type=script&lang=js"
export * from "./DateAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__